import { render, staticRenderFns } from "./updatePTSB.vue?vue&type=template&id=77137d70&lang=pug&"
import script from "./updatePTSB.vue?vue&type=script&lang=js&"
export * from "./updatePTSB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports